import countries from "i18n-iso-countries";
import enCountries from "i18n-iso-countries/langs/en.json";
import huCountries from "i18n-iso-countries/langs/hu.json";
import React from "react";
import { IntlProvider as DefaultIntlProvider } from "react-intl";

import { Locale } from "lib/build/concepts";
import { translations as libTranslations } from "lib/build/intl/translations";

import { useAuthState } from "src/features/auth";
import { translations as appTranslations } from "src/messages/translations";

countries.registerLocale(huCountries);
countries.registerLocale(enCountries);

const defaultLocale = Locale.HU;
const translations = {
	[Locale.HU]: {
		...libTranslations[Locale.HU],
		...appTranslations[Locale.HU]
	},
	[Locale.EN]: {
		...libTranslations[Locale.EN],
		...appTranslations[Locale.EN]
	}
};

export const IntlProvider: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => {
	const locale = useLocale();
	return (
		<DefaultIntlProvider
			defaultLocale={locale}
			locale={locale}
			messages={translations[locale]}
		>
			{children}
		</DefaultIntlProvider>
	);
};

function useLocale(): Locale {
	const { user } = useAuthState();
	return React.useMemo(
		() =>
			user === null
				? defaultLocale
				: user.defaultLanguage || defaultLocale,
		[user]
	);
}
